import { render, staticRenderFns } from "./ApplicationPaidTaxesListItem.vue?vue&type=template&id=72715f09&lang=pug&"
import script from "./ApplicationPaidTaxesListItem.vue?vue&type=script&lang=js&"
export * from "./ApplicationPaidTaxesListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports